export const PLACEMENT = {
  top: "top" as const,
  right: "right" as const,
  bottom: "bottom" as const,
  left: "left" as const,
}
